module.exports = __webpack_public_path__ + "img/xlsx.72e16489.svg";